import { useEffect, useState } from 'react';
import { reduced } from './hooks';

const CMD = 'ABC firmasına 50 adet DN50 flanş için teklif hazırla.';
const STEPS = [['Talep anlaşıldı', 'Müşteri + miktar'], ['Veri eşleştirildi', 'ERP / Excel'], ['Onay bekleniyor', 'Kritik kontrol noktası']];

// Hero'daki döngüsel ürün animasyonu: komut yazılır, plan oluşur, onay beklenir.
export default function HeroMock() {
  const [typed, setTyped] = useState(reduced() ? CMD.length : 0);
  const [done, setDone] = useState(reduced() ? 3 : 0);
  const [cycle, setCycle] = useState(0);

  useEffect(() => {
    if (reduced()) return;
    let off = false;
    const timers = [];
    const at = (ms, fn) => timers.push(setTimeout(() => { if (!off) fn(); }, ms));
    setTyped(0); setDone(0);
    CMD.split('').forEach((_, i) => at(700 + i * 38, () => setTyped(i + 1)));
    const t = 700 + CMD.length * 38;
    STEPS.forEach((_, i) => at(t + 500 + i * 900, () => setDone(i + 1)));
    at(t + 500 + STEPS.length * 900 + 4200, () => setCycle(c => c + 1));
    return () => { off = true; timers.forEach(clearTimeout); };
  }, [cycle]);

  return (
    <div className="mock" aria-hidden="true">
      <div className="mock-bar"><i /><i /><i /><span>VİZOVA · Komut merkezi</span></div>
      <div className="mock-body">
        <div className="mock-user"><div>{CMD.slice(0, typed)}{typed < CMD.length && <b className="caret" />}</div></div>
        <div className="mock-agent">
          <div className="mock-head"><svg viewBox="0 0 100 100"><polygon points="4,6 30,6 50,78 70,6 96,6 61,100 39,100" fill="#D0202E" /><polygon points="50,78 61,100 39,100" fill="#96101C" /></svg><b>VİZOVA</b><span>{done >= 3 ? 'onay bekliyor' : typed >= CMD.length ? 'çalışıyor' : 'hazır'}</span></div>
          {STEPS.map(([t, d], i) => (
            <div key={t} className={'mock-step' + (done > i ? ' done' : done === i && typed >= CMD.length ? ' run' : '')}>
              <span className="ic" /><span className="t">{t}<small>{d}</small></span>
            </div>
          ))}
          <div className={'mock-approve' + (done >= 3 ? ' on' : '')}>Kullanıcı onayı <span>Onayla ve PDF oluştur</span></div>
        </div>
      </div>
    </div>
  );
}
